import { render, staticRenderFns } from "./pzTop.vue?vue&type=template&id=59a4e0dc&scoped=true&"
import script from "./pzTop.vue?vue&type=script&lang=ts&"
export * from "./pzTop.vue?vue&type=script&lang=ts&"
import style0 from "./pzTop.vue?vue&type=style&index=0&id=59a4e0dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a4e0dc",
  null
  
)

export default component.exports